import { useSprintQueryClient } from "sprint-common-web";

import { GetSingleTvSeriesResponse } from "../../../api/catalogue-api/tv-api/GetSingleTvSeriesResponse";
import { useCatalogueTvApi } from "../../../api/catalogue-api/tv-api/useCatalogueTvApi";
import { TvSeriesQueryKey } from "./keys/TvSeriesQueryKey";

export const useGetTvSeriesById = () => {
    const queryClient = useSprintQueryClient();
    const { getSingleTvSeries: getTvSeriesByIdUncached } = useCatalogueTvApi();

    const getTvSeriesById = (tvSeriesId: string): Promise<GetSingleTvSeriesResponse> => {
        return queryClient.fetchQuery({
            queryKey: [TvSeriesQueryKey.TvSeriesDetails, tvSeriesId],
            queryFn: () => getTvSeriesByIdUncached(tvSeriesId),
            staleTime: 20000
        });
    };

    return { getTvSeriesById };
};
